module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 95.23a44a5e.png";